import Vue from 'vue'

export const start = ({ commit }) => {
  setInterval(() => {
    commit('updateTime')
  }, 60 * 1000) // once a minute
}

export const confirmPrivacyPolicy = ({ commit }) => {
  commit('CONFIRM_PRIVACY_POLICY')
}

export const updateLastVersion = ({commit}, newVersion) => {
  commit('UPDATE_LAST_VERSION', newVersion)
}

export const setServerVersion = ({commit}, serverVersion) => {
  commit('SET_SERVER_VERSION', serverVersion)
}

export const resetLoading = ({ commit }) => {
  commit('resource/LOADING_DONE', {root: true})
  commit('editor/LOADING_DONE', {root: true})
  commit('user/LOADING_DONE', {root: true})
  commit('publicView/LOADING_DONE', {root: true})
  commit('publicView/LOADING_DONE_STAFF', {root: true})
  commit('tree/LOADING_DONE', {root: true})
  commit('aboutme/LOADING_DONE', {root: true})
}

export const setLanguage = ({ commit }, locale) => {
  commit('SET_LANGUAGE', locale)
  Vue.config.language = locale
}



// WEBPACK FOOTER //
// ./src/store/actions.js